export enum DbKind {
    ROOT = 0,
    PRIMARY = 1,
    SLAVE = 2
}